import { HostListener, Directive } from '@angular/core';

@Directive()
export abstract class ComponentCanDeactivate {
  public abstract canDeactivate(): boolean;

  @HostListener('window:beforeunload', ['$event'])
  public unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
